module.exports = "https://cdn.spacehpc.com/img/bilibili.jpg";